import { Box } from '@hivebrite/design-system/Box';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { CaptchaFormikField } from 'hb-react/shared/components/Captcha/CaptchaFormikField';
import { useFeature } from 'hb-react/shared/hooks/useFeature';

export const ReCaptcha = () => {
  const { feature: events } = useFeature('events');
  const { currentUser } = useDefaultAppContexts();

  if (
    !events.config?.public_form_recaptcha_enabled ||
    window.is_from_china ||
    currentUser
  ) {
    return null;
  }

  return (
    <Box mt={5}>
      <CaptchaFormikField />
    </Box>
  );
};
